import { nowIso } from '../domain/time.js';
export class AuditRepository {
    driver;
    constructor(driver) {
        this.driver = driver;
    }
    async record(entry) {
        try {
            await this.driver.execute({
                sql: `INSERT INTO local_audit (user_id, action, entity, entity_id, summary, metadata_json, at)
              VALUES (?, ?, ?, ?, ?, ?, ?)`,
                params: [
                    entry.userId ?? null,
                    entry.action,
                    entry.entity,
                    entry.entityId ?? null,
                    entry.summary,
                    entry.metadataJson ?? null,
                    nowIso(),
                ],
            });
        }
        catch {
            // Audit must never fail a business write (same stance as the server).
        }
    }
    async list(limit = 100) {
        const rows = await this.driver.query({
            sql: 'SELECT id, user_id, action, entity, summary, at FROM local_audit ORDER BY id DESC LIMIT ?',
            params: [limit],
        });
        return rows.map((r) => ({
            id: Number(r.id),
            userId: r.user_id == null ? null : String(r.user_id),
            action: String(r.action),
            entity: String(r.entity),
            summary: String(r.summary),
            at: String(r.at),
        }));
    }
}
//# sourceMappingURL=audit.js.map